import { haversineMeters } from '../tasting/geo.js';
import { foldText } from '../text/normalize.js';
/**
 * Stores (docs/finished/ingredient-catalog-spec.md 6.7): the Overpass query for shops, the chain name
 * of an OSM element and the on-device proposal for "Shopping at …".
 */
export const STORE_SHOP_TAGS = [
    'supermarket',
    'convenience',
    'bakery',
    'butcher',
    'greengrocer',
    'farm',
    'organic',
    'health_food',
    'beverages',
    'deli',
    'cheese',
    'seafood',
    'wholesale',
    'chemist',
];
export const STORE_PROPOSAL_RADIUS_M = 150;
/** One request for shops around a point; same fair-use rules as the restaurant lookup. */
export function overpassShopsQuery(center, radiusM, timeoutS = 8) {
    const around = `around:${Math.round(radiusM)},${center.lat.toFixed(6)},${center.lng.toFixed(6)}`;
    return [
        `[out:json][timeout:${timeoutS}];`,
        '(',
        `nwr(${around})["shop"~"^(${STORE_SHOP_TAGS.join('|')})$"]["name"];`,
        `nwr(${around})["amenity"="marketplace"]["name"];`,
        ');',
        'out center tags 40;',
    ].join('');
}
/** Name used to find or create the chain a branch belongs to. */
export function normalizeStoreName(name) {
    return foldText(name).replace(/\s+/g, ' ').trim();
}
/**
 * Chain name of an OSM element: the `brand` tag, else `operator`. Returns null when the
 * element's own name already is the chain name and nothing more specific is known.
 */
export function chainNameFromTags(tags) {
    const pick = (key) => {
        const v = tags?.[key];
        return typeof v === 'string' && v.trim() ? v.trim().slice(0, 120) : null;
    };
    return pick('brand') ?? pick('operator');
}
/** The nearest store inside the radius, or null. Runs on the device, online or not. */
export function nearestStore(position, stores, radiusM = STORE_PROPOSAL_RADIUS_M) {
    let best = null;
    for (const store of stores) {
        const distanceM = haversineMeters(position, store);
        if (distanceM > radiusM)
            continue;
        if (!best || distanceM < best.distanceM)
            best = { store, distanceM };
    }
    return best;
}
//# sourceMappingURL=stores.js.map